import { Download } from "@mui/icons-material";
import MuiButton from "@mui/material/Button";

export interface FileDownloadButtonProps {
  label: string;
  fileName: string;
  href: string;
}

export const FileDownloadButton = ({
  label,
  fileName,
  href,
}: FileDownloadButtonProps) => {
  return (
    <MuiButton
      variant="outlined"
      href={href}
      download={fileName}
      target="_blank"
      rel="noopener noreferrer"
      startIcon={<Download />}
      fullWidth
      sx={(theme) => ({
        height: {
          xs: theme.spacing(5),
          sm: theme.spacing(8),
        },
      })}>
      {label}
    </MuiButton>
  );
};

export default FileDownloadButton;
